import type { User } from '../types';

export function requiresOnboarding(user: User | null | undefined): boolean {
  return Boolean(
    user?.onboarding?.required && user.onboarding.status !== 'verified'
  );
}

export function requiresEmailVerification(
  user: User | null | undefined
): boolean {
  return Boolean(
    user &&
      user.emailVerificationRequired !== false &&
      user.emailVerified === false
  );
}

export function authenticatedHomePath(user: User | null | undefined): string {
  if (!user) return '/login';
  if (requiresOnboarding(user)) return '/onboarding';
  if (requiresEmailVerification(user)) return '/verify-email';
  if (user.isAdmin) return '/admin/home';
  if (user.isSupport) return '/admin/profile';
  return '/home';
}
